'use client';

import Markdown from 'react-markdown';
import { MessageCircle } from 'lucide-react';

interface AnswerCardProps {
  answer: string;
  isStreaming: boolean;
}

export function AnswerCard({ answer, isStreaming }: AnswerCardProps) {
  return (
    <div className="px-3 pt-2.5 sm:px-4">
      <div className="flex items-start gap-2.5">
        <MessageCircle className="mt-0.5 h-3 w-3 shrink-0 text-primary/70" />
        <div className="min-w-0 flex-1 pb-2.5 pt-0.5 text-xs font-medium leading-relaxed text-foreground prose prose-xs prose-slate max-w-none dark:prose-invert prose-p:my-0 prose-ul:my-1 prose-li:my-0 prose-a:text-primary prose-a:underline prose-strong:text-foreground">
          <Markdown
            components={{
              a: ({ children, href }) => (
                <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
              ),
            }}
          >
            {answer}
          </Markdown>
          {isStreaming && (
            <span className="ml-0.5 inline-block h-3 w-0.5 animate-pulse bg-foreground/40" />
          )}
        </div>
      </div>
    </div>
  );
}
